/* ==========================================================================
   SearcherLeiPackages > Class
   ========================================================================== */

/* Modules */
const SelectClient = require('@bluekiri/alexandria-contrib-components/components/select/client/js/index');
const config = require('./config');

/**
 * initRooms: export function: initialize the selects (resident, bonuses)
 * @param {Object} instance instace of the panel
 * @returns void
 */
function initClass(selector, instance) {
    const inst = instance;
    const sel = `${selector} ${config().class.selector}`;

    const configSelect = {
        enableClick: true,
        choices: {
            searchEnabled: false,
            searchPlaceholderValue: '',
            loadingText: 'Cargando...',
            noResultsText: 'No se han encontrado resultados',
            noChoicesText: 'No hay opciones para selecionar',
            itemSelectText: 'Tocar para seleccionar',
            addItemText: ''
        }
    };

    // init select resident
    inst.class = SelectClient(sel, configSelect);
}

module.exports = {
    initClass
};
